import { getContext } from '@fiverr-private/fiverr_context';
import { getIsUserInTaxesRegulatedState } from '../getIsUserInTaxesRegulatedState/getIsUserInTaxesRegulatedState';

interface GetShouldDisplayTaxes {
    regionCode?: string;
}

export const getShouldDisplayTaxes = ({ regionCode = '' }: GetShouldDisplayTaxes): boolean => {
    const { countryCode } = getContext();
    return getIsUserInTaxesRegulatedState(countryCode, regionCode);
};
